import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入element ui
import ElementUI from 'element-ui'
import 'animate.css';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/index.less' // 引入全局初始化样式
import '@/icons/'
import jquery from 'jquery'
Vue.prototype.$ = jquery
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from, next) => {
  document.body.scrollTop = 0;

  document.documentElement.scrollTop = 0;
});